<template>
  <div>
    <PageHeader :title="title" :items="headerItems" />
    <div class="main">
      <b-row>
        <b-col cols="4">
          <div class="inner__style">
            <div v-if="imageSource.length === 0" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="openCropperModal()">
              <div>
                <i class="fas fa-cloud-upload-alt icon-size"></i>
                <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
              </div>
            </div>
            <div v-else class="grand-parent">
              <div class="upload-photo-parent">
                <div class="d-flex align-items-center justify-content-start preview__image_container">
                  <div class="remove-icon" @click="removeImage(index)">
                    <i class="fa fa-times"></i>
                  </div>
                  <img :src="imageSource[0]" alt="" />
                  <span class="image__preview__title">عکس روی گازانتی</span>
                </div>
                <hr />
                <div v-if="imageSource.length < 2" class="d-flex align-items-center justify-content-start preview__image_container" @click="openCropperModal()">
                  <div class="plus__icon__container">
                    <i class="fa fa-plus"></i>
                  </div>
                  <span class="image__preview__title">بارگذاری عکس پشت گارانتی</span>
                </div>
                <div v-else class="d-flex align-items-center justify-content-start preview__image_container">
                  <div class="remove-icon" @click="removeImage(index)">
                    <i class="fa fa-times"></i>
                  </div>
                  <img :src="imageSource[1]" alt="" />
                  <span class="image__preview__title">عکس پشت گارانتی</span>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="8">
          <div class="inner__style">
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">اطلاعات گارانتی</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="section">
                <div class="mb-3">
                  <BaseText @input="guranteeName = $event" :value="guranteeName" title="نام" placeholder="نام" />
                </div>
                <div class="">
                  <BaseText @input="guranteeDuration = $event" :value="guranteeDuration" inputType="number" title="مدت زمان(ماه)" placeholder="مدت زمان" />
                </div>
              </div>
              <div class="buttonClass">
                <Button @click.native="submit" text="ثبت" btnClass="ms-2 aprove btn-border" :loading="btnLoading" />
                <b-button @click="cancelModal = true" class="cancleButton">
                  <span class="cancleTitle">انصراف</span>
                </b-button>
                <b-modal v-model="cancelModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
                  <div class="error-wrapper">
                    <div class="mb-4">
                      <img src="@/assets/images/checked1.svg" />
                    </div>
                    <div class="error-title">
                      آیا از انصراف خود مطمئن هستید؟
                    </div>
                    <div class="buttons">
                      <div @click="cancelModal = false">
                        <button class="cancelButton">خیر</button>
                      </div>
                      <div
                        @click="
                          cancelModal = false
                          $router.go(-1)
                        "
                      >
                        <button class="approveButton">بلی</button>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
        <div class="p-3">
          <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="addImageToListOfImages($event)" />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import BaseText from '@/components/common/form/formModules/BaseText.vue'
import ImageCropper from '../../user/ImageCropper.vue'
import fileMannager from '../../../services/file'
import productAdvanceDataProvider from '../../../services/productAdvance'
import Button from '../../common/Button.vue'

export default {
  components: {
    PageHeader,
    BaseText,
    ImageCropper,
    Button,
  },
  data() {
    return {
      btnLoading: false,
      cropperLoading: false,
      guranteeName: '',
      guranteeId: null,
      guranteeDuration: '',
      selectedColor: '#837499',
      imageSource: [],
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'اضافه کردن گارانتی جدید',
          active: true,
        },
      ],
      cancelModal: false,
      title: 'اضافه کردن گارانتی',
    }
  },
  methods: {
    submit() {
      this.btnLoading = true
      if (this.$route.params.id) {
        productAdvanceDataProvider
          .editGuarantee({
            id: this.$route.params.id,
            name: this.guranteeName,
            frontImage: this.imageSource[0],
            backImage: this.imageSource[1],
            duration: Number(this.guranteeDuration),
          })
          .then(res => {
            this.btnLoading = false
            
            this.$router.push({
              path: '/list/guarantee',
            })
          })
      } else {
        productAdvanceDataProvider
          .addGurantee({
            name: this.guranteeName,
            duration: Number(this.guranteeDuration),
            frontImage: this.imageSource[0],
            backImage: this.imageSource[1],
          })
          .then(res => {
            this.btnLoading = false
            
            this.$router.push({
              path: '/list/guarantee',
            })
          })
      }
    },
    removeImage(payload) {
      this.imageSource.splice(payload, 1)
    },
    addImageToListOfImages(payload) {
      this.cropperLoading = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then(res => {
          this.cropperLoading = false
          
          this.imageSource.push(res.data.data.downloadUrl)
          this.$bvModal.hide('cropperModal')
        })
    },
    openCropperModal() {
      this.$bvModal.show('cropperModal')
    },
  },
  mounted() {
    if (this.$route.params.id) {
      productAdvanceDataProvider.getGuranteeDetail({ id: this.$route.params.id }).then(res => {
        const response = res.data.data
        
        this.guranteeName = response.name
        this.guranteeDuration = response.duration
        this.imageSource[0] = response.frontImage
        this.imageSource[1] = response.backImage
        this.guranteeId = response.id
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.main {
  background: #f8f8fb;
  border-radius: 8px;
}
.inner__style {
  background-color: white;
  padding: 23px;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.btn-border {
  border-radius: 4px !important;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
.submitButton {
  font-size: 14px;
  padding: 8px 45px;
  color: white;
  background: #556ee6;
  border: 1px solid #556ee6;
  box-sizing: border-box;
  border-radius: 4px;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}

.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px;
    margin-left: 12px;
    color: white;
    background: #74788d;
    border-radius: 4px;
  }
}
.upload-text-size {
  font-size: 20px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.upload-photo-parent {
  width: 100%;
}
.grand-parent {
  padding: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
  position: relative;
}
.preview__image_container {
  position: relative;
  .plus__icon__container {
    width: 120px;
    height: 98px;
    border-radius: 4px;
    border: dashed 2px #ced4da;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 50px;
      color: #ced4da;
    }
  }
  img {
    width: 120px;
    height: 98px;
    border-radius: 4px;
  }
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #495057;
    margin-right: 16px;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
</style>
